module.exports = __webpack_public_path__ + "img/left-tree.7fd12e42.png";